import { Button, SvgIcon } from "@mui/material";

interface MicrosoftLoginButtonProps {
  onClick: () => void;
  isDisabled: boolean;
}

const MicrosoftIcon = () => (
  <SvgIcon viewBox="0 0 21 21" sx={{ fontSize: 20 }}>
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </SvgIcon>
);

const MicrosoftLoginButton = ({
  onClick,
  isDisabled,
}: MicrosoftLoginButtonProps) => {
  return (
    <Button
      fullWidth
      startIcon={<MicrosoftIcon />}
      sx={{
        textTransform: "none",
        borderRadius: "12px",
        height: 50,
        border: "1px solid rgba(14, 134, 212, 0.15)",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        backdropFilter: "blur(8px)",
        color: "#1a2332",
        fontSize: "15px",
        fontWeight: 500,
        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
        boxShadow: "none",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(14, 134, 212, 0.3)",
          boxShadow: "0 2px 8px rgba(14, 134, 212, 0.1)",
          transform: "translateY(-1px)",
        },
        "&:active": {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          boxShadow: "none",
          transform: "translateY(0)",
        },
      }}
      onClick={onClick}
      disabled={isDisabled}
    >
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftLoginButton;
